var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-selector',_vm._b({attrs:{"label":_vm.$tc('item.unit', 2),"items":_vm.items,"value":_vm.value,"item-text":"attributes.symbolLabel","item-value":"attributes.symbol"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'base-selector',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }